module.exports = __webpack_public_path__ + "static/media/I.5eda854c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/I.png
// module id = 50
// module chunks = 0